<ds-modal [modal]="modal" [title]="'share_report_modal_title' | translate" [closeAllModals]="false" [maxWidthPercentage]="50">
  <div class="modal-body-content">
    <div class="margin-bottom">
      <div class="margin-bottom-xs d-flex align-items-center justify-content-between">
        <span class="label">{{ 'audit_rule_property_nodesHTML' | translate }}:</span>
        <ds-copy [textToCopy]="modalInputData.data.url"></ds-copy>
      </div>
      <div class="d-block p-2 issue-url">
        <pre>{{ modalInputData.data.url }}</pre>
      </div>
    </div>
  </div>

  <ng-template ds-modal-slide-out-footer>
    <div class="w-100 d-flex">
      <button ds-button [variant]="DsButtonVariants.secondary" (click)="modal.dismiss()">
        {{ 'label_close' | translate }}
      </button>
    </div>
  </ng-template>
</ds-modal>
